<script>
	const articleTabMixin = require('mixins/article-tab');

	module.exports = {
		mixins: [articleTabMixin],
		props: ['article', 'routeContext', 'paragraphsNumbered'],
		components: {
			'content-body': require('components/content-body.vue').default
		},
		modelData: ['userContext', 'contentSection', 'whiteboardView']
	};
</script>
<style lang="scss">
	@import 'config/variables';

	.article-body {
		> .content-column article {
			padding-right: $size-medium;
		}
	}
</style>
<template>
	<content-body
		:article="article"
		:article-list="articleList"
		:selected-article="selectedArticle"
		:route-context="routeContext"
		:on-article-select="onArticleSelect"
		:force-highlighting="whiteboardView"
		:paragraphs-numbered="paragraphsNumbered"></content-body>
</template>
